import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingEventName, UploadPhotoTakePhotoOptionCanceledTrackingEvent } from "./tracking";

interface TrackUploadPhotoTakePhotoOptionCanceledFunction {
  (): void;
}

interface UseTrackUploadPhotoTakePhotoOptionCanceledFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string;
  readonly tradename: Tradename;
}

interface UseTrackUploadPhotoTakePhotoOptionCanceledFunction {
  (agrs: UseTrackUploadPhotoTakePhotoOptionCanceledFunctionArgs): TrackUploadPhotoTakePhotoOptionCanceledFunction;
}

const useTrackUploadPhotoTakePhotoOptionCanceled: UseTrackUploadPhotoTakePhotoOptionCanceledFunction = ({
  country,
  segment,
  customerId,
  tradename,
}) => {
  const emitUserEvent = useEmitUserEvent<UploadPhotoTakePhotoOptionCanceledTrackingEvent>();

  const trackUploadPhotoTakePhotoOptionCanceled: TrackUploadPhotoTakePhotoOptionCanceledFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.UPLOAD_PHOTO_TAKE_PHOTO_OPTION_CANCELED,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_photos`,
      store: country,
      segment,
      userId: customerId,
      tradename,
    });
  }, [country, customerId, tradename, emitUserEvent, segment]);

  return trackUploadPhotoTakePhotoOptionCanceled;
};

export { useTrackUploadPhotoTakePhotoOptionCanceled };
